class FormTerminalManager {
  constructor (requestedTerminal) {
    this.requestedTerminal = requestedTerminal
  }

  getField (defaultValues) {
    const initialValues = {
      serialNumber: this.requestedTerminal?.serial_number ?? null,
      status: this.requestedTerminal?.status ?? null
    }
    const fields = []
    Object.keys(initialValues).forEach(key => {
      if (initialValues[key]) {
        return fields.push(key)
      }
    })
    return {
      ...defaultValues,
      initialValues,
      fields
    }
  }
}
export default FormTerminalManager
